import React from 'react';
import { formatSecondsShort } from '../../utils/audio-segments';
import {
  BADGE_COLORS,
  BADGE_LABELS,
  SectionSummaryCard,
  SlideBadgeType,
} from '../../utils/slide-panel.utils';
import styles from './video-analytics.module.scss';

type Props = {
  cards: SectionSummaryCard[];
  onSeek: (seconds: number) => void;
};

const SectionSummaryCards: React.FC<Props> = ({ cards, onSeek }) => {
  if (!cards.length) return null;

  return (
    <div className={styles.sectionSummary}>
      <div className={styles.sectionSummaryHeader}>
        <span className={styles.sectionSummaryTitle}>Суммаризация презентации</span>
        <span className={styles.sectionSummaryBadge}>ИИ · Qwen</span>
      </div>
      <div className={styles.sectionSummaryList}>
        {cards.map(card => (
          <button
            key={card.num}
            type="button"
            className={styles.sectionSummaryCard}
            onClick={() => onSeek(card.start_ts)}
          >
            <div className={styles.sectionSummaryCardTop}>
              <span className={styles.sectionSummaryNum}>
                {String(card.num).padStart(2, '0')}
              </span>
              <span className={styles.sectionSummaryCardTitle}>{card.title}</span>
            </div>
            <p className={styles.sectionSummaryCardText}>{card.summary}</p>
            <div className={styles.sectionSummaryCardFooter}>
              <span className={styles.sectionSummaryCardTime}>
                {formatSecondsShort(card.start_ts)}
              </span>
              <div className={styles.sectionSummaryBadges}>
                {card.badges.map((b: SlideBadgeType) => (
                  <span
                    key={b}
                    className={styles.sectionSummaryBadgeChip}
                    style={{
                      color: BADGE_COLORS[b],
                      borderColor: BADGE_COLORS[b],
                      backgroundColor: `${BADGE_COLORS[b]}14`,
                    }}
                  >
                    {BADGE_LABELS[b]}
                  </span>
                ))}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SectionSummaryCards;
